// Leadets uppföljning: nästa steg, datum, tid, status och mejlpåminnelse.
// Samma fält i aktivitetsdialogen och i redigeringsdialogen, se
// uppfoljningFranLead/uppfoljningPatch i pipelineFlode.js.
import React from 'react';
import { Box, TextField, MenuItem, Switch, Typography } from '@mui/material';
import { UPPFOLJNING_STATUSAR, PAMINNELSE_DAGAR_FORE } from './pipelineFlode';

/**
 * @param {object}   p.value     uppfoljningFranLead(...)
 * @param {Function} p.onChange  (ändrade fält) => void
 */
export default function UppfoljningFalt({ value, onChange }) {
  const v = value;
  const harDatum = !!v.nextFollowUp;
  const paminnelse = harDatum && v.nextFollowUpReminder;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField fullWidth label="Nästa steg"
        placeholder="t.ex. Demo för IT-chefen, skicka reviderad offert"
        value={v.nastaSteg}
        onChange={e => onChange({ nastaSteg: e.target.value })} />
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
        <TextField label="Nästa uppföljning" type="date" sx={{ flex: '1 1 170px' }}
          InputLabelProps={{ shrink: true }}
          value={v.nextFollowUp}
          onChange={e => onChange({ nextFollowUp: e.target.value })} />
        <TextField label="Klockslag" type="time" sx={{ flex: '0 1 120px' }}
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
          disabled={!harDatum}
          value={v.nextFollowUpTime}
          onChange={e => onChange({ nextFollowUpTime: e.target.value })} />
        <TextField select label="Status" sx={{ flex: '0 1 150px' }}
          disabled={!harDatum}
          value={v.nextFollowUpStatus}
          onChange={e => onChange({ nextFollowUpStatus: e.target.value })}>
          {UPPFOLJNING_STATUSAR.map(s => <MenuItem key={s.key} value={s.key}>{s.label}</MenuItem>)}
        </TextField>
      </Box>
      <Box
        onClick={() => harDatum && onChange({ nextFollowUpReminder: !v.nextFollowUpReminder })}
        sx={{
          border: '1px solid',
          borderColor: paminnelse ? '#FF6B00' : 'rgba(0,0,0,0.23)',
          borderRadius: 1.5, px: 2, py: 1,
          bgcolor: paminnelse ? '#FFF8F5' : harDatum ? 'transparent' : '#fafafa',
          cursor: harDatum ? 'pointer' : 'default',
          opacity: harDatum ? 1 : 0.45,
          transition: 'all 0.18s',
          display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: '1 1 200px' }}>
          <Switch size="small" checked={paminnelse} disabled={!harDatum}
            onClick={e => e.stopPropagation()}
            onChange={e => onChange({ nextFollowUpReminder: e.target.checked })}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': { color: '#FF6B00' },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#FF6B00' },
            }} />
          <Typography variant="body2" fontWeight={paminnelse ? 600 : 400}
            color={paminnelse ? '#FF6B00' : 'text.secondary'}>
            Påminnelse via e-post
          </Typography>
        </Box>
        {paminnelse && (
          <Box sx={{ display: 'flex', gap: 1 }} onClick={e => e.stopPropagation()}>
            <TextField select size="small" label="Skicka" sx={{ width: 160 }}
              value={v.nextFollowUpReminderDays}
              onChange={e => onChange({ nextFollowUpReminderDays: Number(e.target.value) })}>
              {PAMINNELSE_DAGAR_FORE.map(d => <MenuItem key={d.key} value={d.key}>{d.label}</MenuItem>)}
            </TextField>
            <TextField label="Tid" type="time" size="small" sx={{ width: 105 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 900 }}
              value={v.nextFollowUpReminderTime}
              onChange={e => onChange({ nextFollowUpReminderTime: e.target.value })} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
